<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
      class="elevation-1"
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer" class="white--text"></v-toolbar-side-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text">Markup</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="refreshList()" class="white--text">
        <v-icon>autorenew</v-icon>
      </v-btn>
    </v-toolbar>
    <v-content>
      <v-list two-line fill-height>
        <div v-for="(item, index) in items" :key="index">
          <v-list-tile
            :key="item.userId"
            avatar
            ripple
            :href="'/markup/' + item.productMarkupId"
            :class="(index % 2 === 0 ? 'row1' : 'row2')"
          >
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.name }}
              </v-list-tile-title>
              <v-list-tile-sub-title class="text--primary"></v-list-tile-sub-title>
              <v-list-tile-sub-title></v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn icon :href="'/markup/' + item.productMarkupId">
                <v-icon color="primary">chevron_right</v-icon>
              </v-btn>
            </v-list-tile-action>

          </v-list-tile>
          <v-divider
            v-if="index + 1 < items.length"
            :key="index"
          ></v-divider>
        </div>
        <template
          v-if="items.length <= 0"
        >
          <v-flex
            xs12
            justify-center
            align-center
            text-xs-center
          >
            <v-icon x-large color="primary">error_outline</v-icon>
            <div>
              No markup yet
            </div>
          </v-flex>
        </template>
      </v-list>
      <v-dialog v-model="dialogAddProductMarkup" max-width="290">
        <v-card>
          <v-card-title class="headline">
            Add Markup
          </v-card-title>
          <v-card-text>
            <v-form ref="formAddProductMarkup" v-model="frmAddProductMarkupValid" @submit.prevent="">
              <v-text-field
                label="Name"
                v-model="txtProductMarkupName"
                :rules="[v => !!v || 'Name is required', v => (v && v.length >= 3) || 'Name must be 3 characters or more']"
                @keyup.enter="(frmAddProductMarkupValid ? addProductMarkup(txtProductMarkupName) : '')"
                required
              ></v-text-field>
              <v-btn
                :disabled="!frmAddProductMarkupValid"
                @click="addProductMarkup(txtProductMarkupName)"
              >
                Add
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogEditProductMarkup" max-width="290">
        <v-card>
          <v-card-title class="headline">
            Edit Markup Name
          </v-card-title>
          <v-card-text>
            <v-form ref="formEditProductMarkup" v-model="frmEditProductMarkupValid" @submit.prevent="">
              <v-text-field
                label="Name"
                v-model="txtProductMarkupNewName"
                :rules="[v => !!v || 'Name is required', v => (v && v.length >= 3) || 'Name must be 3 characters or more']"
                @keyup.enter="(frmEditProductMarkupValid ? editProductMarkup(dialogProductMarkupId, txtProductMarkupNewName) : '')"
                required
              ></v-text-field>
              <v-btn
                :disabled="!frmEditProductMarkupValid"
                @click="editProductMarkup(dialogProductMarkupId, txtProductMarkupNewName)"
              >
                Save
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogDeleteProductMarkup" max-width="290">
        <v-card>
          <v-card-title class="headline">Confirmation</v-card-title>

          <v-card-text>
            Are you sure to delete this markup?
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="secondary"
              class="grey--text"
              @click="dialogDeleteProductMarkup = false"
            >
              Cancel
            </v-btn>

            <v-btn
              color="primary"
              @click="dialogDeleteProductMarkup = false; deleteProductMarkup(dialogProductMarkupId);"
            >
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-fab-transition>
        <v-btn
          color=primary
          dark
          fab
          fixed
          bottom
          right
          class="mr-4"
          @click="openAddProductMarkupDialog()"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-fab-transition>
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>
  </div>
</template>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import Loading from '@/components/Loading.vue'
import axios from 'axios'
import router from '../router'

export default {
  props: [
    'parentId'
  ],
  components: {
    SideDrawer,
    Loading
  },
  data () {
    return {
      drawer: false,
      loading: false,
      dialogDeleteProductMarkup: false,
      dialogEditProductMarkup: false,
      dialogAddProductMarkup: false,
      dialogProductMarkupId: null,
      frmAddProductMarkupValid: false,
      txtProductMarkupName: '',
      frmEditProductMarkupValid: false,
      txtProductMarkupNewName: '',
      items: []
    }
  },

  mounted () {
    this.openDrawerForDesktop()
    this.getProductMarkups()
  },

  methods: {
    openAddProductMarkupDialog: function () {
      this.txtProductMarkupName = ''
      this.dialogAddProductMarkup = true
    },
    addProductMarkup: function (name) {
      if (name && name.length > 0) {
        this.dialogAddProductMarkup = false
        this.loading = true
        var paramJson = { name: name }
        axios.post(process.env.VUE_APP_API_ROOT + '/v1/product/markup', paramJson, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(resp => {
            this.loading = false
            console.log(resp.data)
            if (resp.data.status === 'success') {
              this.refreshList()
            } else {
              window.alert(resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=/markups')
              } else if (error.response.status === 403) {
                this.showAlert(error)
              }
              this.loading = false
            }
          })
      }
    },
    openEditProductMarkupDialog: function (productMarkupId, currentName) {
      this.dialogProductMarkupId = productMarkupId
      this.txtProductMarkupNewName = currentName
      this.dialogEditProductMarkup = true
    },
    editProductMarkup: function (productMarkupId, newName) {
      this.dialogEditProductMarkup = false
      this.loading = true
      axios.put(process.env.VUE_APP_API_ROOT + '/v1/product/markup/' + productMarkupId, {
        name: newName
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(resp => {
          this.loading = false
          console.log(resp.data)
          if (resp.data.status === 'success') {
            this.refreshList()
          } else {
            window.alert(resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=/markups')
            } else if (error.response.status === 403) {
              this.showAlert(error)
            }
            this.loading = false
          }
        })
    },
    openDeleteProductMarkupDialog: function (productMarkupId) {
      this.dialogProductMarkupId = productMarkupId
      this.dialogDeleteProductMarkup = true
    },
    deleteProductMarkup: function (productMarkupId) {
      this.dialogDeleteProductMarkup = false
      this.loading = true
      axios.delete(process.env.VUE_APP_API_ROOT + '/v1/product/markup/' + productMarkupId)
        .then(resp => {
          this.loading = false
          console.log(resp.data)
          if (resp.data.status === 'success') {
            this.refreshList()
          } else {
            window.alert(resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=/markups')
            } else if (error.response.status === 403) {
              this.showAlert(error)
            }
            this.loading = false
          }
        })
    },
    refreshList: function () {
      this.items = []
      var _this = this
      return new Promise(function (resolve, reject) {
        var promise = _this.getProductMarkups()
        promise.then(function () {
          resolve()
        })
      })
    },
    getProductMarkups: function () {
      var _this = this
      var promise = new Promise(function (resolve, reject) {
        _this.loading = true
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/product/markups')
          .then(resp => {
            _this.loading = false
            console.log(resp.data)
            if (resp.data.status === 'success') {
              _this.items = resp.data.data
            } else {
              console.log('unable to load markups: ' + resp.data.message)
            }
            resolve()
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=/markups')
                reject(error.response.status)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
                reject(error.response.status)
              }
              _this.loading = false
            }
          })
      })
      return promise
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tabs__slider {
  height: 3px;
}

form {
  width: 100%;
}

</style>
